module.exports = __webpack_public_path__ + "components/breakheader/background/background--7-50dfc16d86abfa641233a09c21a030ff.jpg";